export default __webpack_public_path__ + "static/media/Newspaper-Publication-Audited-Financial-Results.0232490c.pdf";